const buscandoAutomacao = (state) => {
    return state.buscando
}

const listaDeCpes = (state) => {
    return state.items || [];
}

export{
    buscandoAutomacao,
    listaDeCpes
}